import React from 'react';
import classnames from 'classnames';
import { noop, isEmpty } from 'lodash';

import { Icon } from 'modules/icon-bank';
import { getLabel } from 'utils/getLabel';
import { GLOBAL_LABELS, SIZES } from 'constants/common';
import { button as Button } from 'modules/button';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { notificationOverlay as NotificationOverlay } from 'ui/views/widgets/notificationOverlay';
 *
 * // render
 * <NotificationOverlay propName='propValue'/>
 */
export const notificationOverlay = ( props ) => {

    // widget class name
    const widgetClassName = classnames( 'ui-notification-overlay', props.className, {
        [ `ui-notification-overlay--size-${ props.size }` ]: ! isEmpty( props.size ),
        [ `ui-notification-overlay--template-${ props.templateType }` ]: ! isEmpty( props.templateType ),
    } );

    return (
         <div className={ widgetClassName }>

            {/* head */}
            <div className='ui-notification-overlay__head'>
             {/* title */}
             

             {/* close button */}
                <div className='ui-notification-overlay__head__close' onClick={ () => props.closeOverlay() }>
                    <Icon name='close' width='14' height='14' fill='#ffffff' />
                </div>
            </div>

         {/* body */}
         
        <div className='ui-notification-overlay__body-small'>
        
                {/* message and data */}
                <div className='ui-notification-overlay__body-small__message'>
                { props.message }
            </div>

        </div>

         <div className='ui-notification-overlay__actions'>
             <Button
                 className='ui-notification-overlay__actions__close'
                 title={ {
                     refId: '',
                     value: props.size === SIZES.SMALL ? getLabel( GLOBAL_LABELS.DISPLAY_TEXT_OK ) : getLabel( GLOBAL_LABELS.DISPLAY_TEXT_CLOSE ),
                 } }
                 onClick={ () => props.closeOverlay() }
                 size='large'
             />
         </div>
     </div>
    );
};

// set display name
notificationOverlay.displayName = 'notificationOverlay';

// set default props
notificationOverlay.defaultProps = {
    closeOverlay: noop,
    size: null,
    title: null,
    message: null,
    templateType: null, // values: null, 'default', 'fields'
    data: {}, // data for template
};

// prop types
notificationOverlay.propTypes = {};
